const statusList = {
  draft: ['draft'],
  complete: ['invoice generated', 'job complete', 'job closed', 'stored to blockchain'],
  payment_pending: ['factoring invoice review pending', 'payment pending'],
  payment_approved: ['factoring invoice review complete', 'payment approved'],
  shipper_approval_pending: ['shipper review pending', 'approval pending'],
  to_be_pickedup: ['invites sent', 'job awarded', 'job started', 'driver at pick-up location'],
  in_transit: ['in transit', 'loading signature received'],
  droppedoff: [
    'driver at drop-off location',
    'unloading in progress',
    'job complete',
    'unloading signature received',
    'shipper review pending'
  ]
}

// everything except "complete" and "draft"
statusList.active = [
  ...statusList.payment_pending,
  ...statusList.payment_approved,
  ...statusList.shipper_approval_pending,
  ...statusList.to_be_pickedup,
  ...statusList.in_transit,
  ...statusList.droppedoff
]

export default statusList
